import { css, SerializedStyles, useTheme } from '@emotion/react';
import React, { ReactNode } from 'react';
import { UpsunTheme } from '@upsun/react-component-library/src/themes';
import { pxToRem } from '@upsun/react-component-library/src/styles';
import { colors } from '../../utils/colors';
import { mediaQueries } from '@upsun/react-component-library/src/styles/css-utils';

type PricingPagePillProps = {
  children: ReactNode
  css?: SerializedStyles | SerializedStyles[]
};

const PricingPagePill : React.FC<PricingPagePillProps> = ({ children, ...props }) => {
  const theme = useTheme() as UpsunTheme;

  const cardStyles = css`
    background-color: ${theme.name === "light" ? "#fff" : colors.black900};
    border-radius: ${pxToRem(16)};
    padding: ${pxToRem(24)};
    margin-bottom: ${pxToRem(32)};

    ${mediaQueries.lg} {
      padding: ${pxToRem(32)};
    }
  `;

  return (
    <div css={cardStyles} {...props}>{children}</div>
  );
};

export default PricingPagePill;